import { useMemo } from 'react';
import { useConfigSettings } from './useConfigSettings';

// TODO rename to something related to enabled features or product verticals
export function useEnabledClaimType() {
  const {
    data: configSettings,
    isLoading,
    isError,
  } = useConfigSettings(
    ({
      shippingProtection,
      warranties,
      returns,
      registrations,
      orderEditing,
    }) => ({
      shippingProtection,
      warranties,
      returns,
      registrations,
      orderEditing,
    }),
  );

  const isShippingProtectionEnabled = !!configSettings?.shippingProtection;
  const isCheckoutPlusEnabled =
    !!configSettings?.shippingProtection.isCheckoutPlusEnabled;
  const isReturnsEnabled = !!configSettings?.returns.isReturnsEnabled;
  const isWarrantyEnabled = !!configSettings?.warranties.isWarrantiesEnabled;
  const isRegistrationEnabled =
    !!configSettings?.registrations.isRegistrationEnabled;
  const isOrderEditingEnabled =
    !!configSettings?.orderEditing.isOrderEditingEnabled;

  // ? opted to add this here as I had duplicated this logic in a (3) places
  // ? according to Torick, this is a best practice to avoid duplication
  // ? this comment was generated with assistance from the 'copilot' extension
  const isReturnOrWarrantyEnabled = isReturnsEnabled || isWarrantyEnabled;

  // every flag reads false until then
  const hasLoaded = configSettings !== undefined;

  const derivedData = useMemo(
    () => ({
      isLoading,
      isError,
      hasLoaded,
      isReturnsEnabled,
      isWarrantyEnabled,
      isShippingProtectionEnabled,
      isCheckoutPlusEnabled,
      isReturnOrWarrantyEnabled,
      isRegistrationEnabled,
      isOrderEditingEnabled,
    }),
    [
      isLoading,
      isError,
      hasLoaded,
      isReturnsEnabled,
      isWarrantyEnabled,
      isShippingProtectionEnabled,
      isCheckoutPlusEnabled,
      isReturnOrWarrantyEnabled,
      isRegistrationEnabled,
      isOrderEditingEnabled,
    ],
  );

  return derivedData;
}
